<template>
    <div class="page-add-live-data-header">

        <div class="container-fluid my-3 py-3">
            <div class="row my-3">
                <div class="col-8">
                    <div class="form-floating">
                        <input id="inputName" type="text" name="name" class="form-control"  v-model="header.name" placeholder="name@example.com">
                        <label for="inputName" class="form-label" >{{ $t("name") }}</label>
                    </div>
                </div>                
            </div>
            <button class="btn btn-success mb-0 ms-auto" @click="submitForm">{{ $t("save") }}</button>
        </div>
    </div>
</template>

<script>
import { createToast } from '@/assets/js/myToast.js'
import axios from 'axios'
export default {
    name: 'EditLiveDataHeader',
    emits: ['closeModal'],
    props: {
        organisation: {
            type: Object,
            required: true,
        },
        liveData: {
            type: Object,
            required: true,
        },
        header: {
            type: Object,
            required: true,
        },
        position: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
        }
    },
    mounted(){
        
    },
    methods: {
        submitForm() {
            
            axios
                .patch(`/api/v1/organisation_live_data_headers/${this.header.id}/`, this.header)
                .then(response => {
        
                    createToast({text: this.$t("header altered")
                        ,type: 'success'})

                this.$emit('closeModal')
                })
                .catch(error => {
                    if (error.response) {
                        if ('detail' in error.response.data){
                            createToast({text: this.$t(error.response.data['detail'])
                                        ,type: 'error'})
                        }                        
                        console.error(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.error(JSON.stringify(error.message))
                    } else {
                        console.error(JSON.stringify(error))
                    }
                })
        }
    },
    computed:{
    }
}
</script>